export default __webpack_public_path__ + "static/media/We Did it400.3b89c206.jpg";